function t() {
  return `${Math.floor(Math.random() * 1e10)}`.padStart(4, "0");
}
export {
  t as a
};
